<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolCommunicationSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "#",
                title: "Email",
                description: "Send and manage email messages for the school community.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Push Notifications",
                description: "Send timely alerts to users on supported devices.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Parent Messaging",
                description: "Communicate directly with parents and guardians.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Teacher Messaging",
                description: "Send messages and updates to school staff.",
                icon: "fa fa-folder"
            },
            {
                to: "#",
                title: "Chat",
                description: "Use direct chat to communicate with members of the school community.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
